import PageInsertionControls from './PageInsertionControlsContainer';

export default PageInsertionControls;